{
  "title": "Packing Management",
  "subtitle": "Pack completed pick lists into shippable packages.",
  "pack": "Pack",
  "print": "Print",
  "view": "View",
  "table": {
    "number": "Packing Task #",
    "source": "Dispatch Order / Pick List",
    "pickList": "Pick List",
    "status": "Status",
    "actions": "Actions"
  },
  "dialog": {
    "lineItems": "Line Items",
    "materialCode": "Code",
    "materialName": "Material",
    "requestedQty": "Requested Qty",
    "issuedQty": "Issued Qty",
    "allocatedQty": "Allocated",
    "packageNo": "Package No",
    "material": "Material",
    "selectMaterial": "Select material",
    "qty": "Qty",
    "weight": "Weight (kg)",
    "carrier": "Carrier",
    "addPackage": "Add Package",
    "complete": "Complete Packing",
    "allocatedOf": "Allocated {{allocated}} of {{total}}",
    "overAllocated": "Package quantities cannot exceed the issued quantity.",
    "materialRequired": "Select a material for every package.",
    "materialOverAllocated": "cannot exceed its issued quantity"
  },
  "cancel": "Cancel"
}
